import Marquee from "react-fast-marquee";

const items = [
  "Strictly confidential",
  "Do not tell Lindsay",
  "RSVP required",
  "Arrive by 7:40pm sharp",
];

export const MarqueeRibbon = () => (
  <div className="border-y border-white/10 bg-[#0A0A0A] py-5" data-testid="marquee-ribbon">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8 text-xs uppercase tracking-[0.3em] text-gold/70">
          {item}
          <span className="inline-block h-1 w-1 rotate-45 bg-gold/50" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
